import { render, staticRenderFns } from "./PointRulesSetting.vue?vue&type=template&id=49d80524&scoped=true&"
import script from "./PointRulesSetting.vue?vue&type=script&lang=js&"
export * from "./PointRulesSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d80524",
  null
  
)

export default component.exports